













































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import NavBar from '@/components/common/NavBar.vue';
import SelectionField from '@/components/common/inputs/SelectionField.vue';
import InputField from '@/components/common/inputs/InputField.vue';
import MappedSelectionField from '@/components/common/inputs/MappedSelectionField.vue'
import {LogoFile, OrganisationModule, OrganisationState } from '@/store/modules/organisation';
import { AuthModule, UserRole } from '@/store/modules/auth';
import OrganisationFormSection from '@/components/organisation/OrganisationFormSection.vue';
import { InhabitantsKeys, InhabitantsLabels } from '@/models/inhabitants';
import Well from '@/components/common/Well.vue';
import WellItem from '@/components/common/WellItem.vue';
import { EmployeesKeys, EmployeesLabels } from '@/models/employees';
import SnackBar from '@/components/common/SnackBar.vue';
import Button from '@/components/common/inputs/Button.vue';
import { CommonModule } from '@/store/modules/common';
import { UserSearchRequest } from '@/store/modules/commonInterfaces';
import InfoTooltip from '@/components/common/InfoTooltip.vue';
import TagSelectorTechnologies from '@/components/common/inputs/TagSelectorTechnologies.vue';
import TagSelectorITSystems from '@/components/common/inputs/TagSelectorITSystems.vue';
import LogoComponent from '@/components/common/inputs/Logo.vue';


@Component({
  components: {
    NavBar,
    OrganisationFormSection,
    SelectionField,
    MappedSelectionField,
    Well,
    WellItem,
    SnackBar,
    Button,
    InputField,
    InfoTooltip,
    TagSelectorTechnologies,
    TagSelectorITSystems,
    LogoComponent
  }
})
export default class Organisation extends Vue {
  @Prop(String) cvr!: string;

  showSaveSuccess = false;
  showSaveError = false;
  logoPlaceholder: LogoFile | null = null;
  maxFileSize = 10000000;

  inhabitantLevels = [
    { value: InhabitantsKeys.BELOW_30000, text: InhabitantsLabels.BELOW_30000 },
    { value: InhabitantsKeys.BELOW_45000, text: InhabitantsLabels.BELOW_45000 },
    { value: InhabitantsKeys.BELOW_60000, text: InhabitantsLabels.BELOW_60000 },
    { value: InhabitantsKeys.BELOW_100000, text: InhabitantsLabels.BELOW_100000 },
    { value: InhabitantsKeys.ABOVE_100000, text: InhabitantsLabels.ABOVE_100000 }
  ];

  employeeLevels = [
    { value: EmployeesKeys.BELOW_1500, text: EmployeesLabels.BELOW_1500 },
    { value: EmployeesKeys.BELOW_3000, text: EmployeesLabels.BELOW_3000 },
    { value: EmployeesKeys.BELOW_5000, text: EmployeesLabels.BELOW_5000 },
    { value: EmployeesKeys.BELOW_10000, text: EmployeesLabels.BELOW_10000 },
    { value: EmployeesKeys.ABOVE_10000, text: EmployeesLabels.ABOVE_10000 }
  ];

  get canEdit() {
    return AuthModule.user && AuthModule.user.cvr === this.cvr && AuthModule.user.roles && AuthModule.user.roles.includes(UserRole.superUser);
  }

  get municipalityName() {
    return OrganisationModule.municipalityName;
  }

  get state() {
    return OrganisationModule;
  }

  get showUploadError() {
    return this.state.showUploadError;
  }

  get showUploadSuccess() {
    return this.state.showUploadSuccess;
  }

  get showRemoveLogoError() {
    return this.state.showRemoveLogoError;
  }

  get showRemoveLogoSuccess() {
    return this.state.showRemoveLogoSuccess;
  }


  get logoName() {
    if (this.logoPlaceholder != null) {
      return this.logoPlaceholder.fileName;
    } else if (this.state.municipalityLogo != null) {
      return this.state.municipalityLogo.fileName;
    }
    return "";
  }

  get technologies() {
    return CommonModule.technologies;
  }

  get itSystems() {
    return CommonModule.itSystems;
  }

  get common() {
    return CommonModule;
  }

  async mounted() {
    OrganisationModule.loadMunicipalityDetails(this.cvr);
    CommonModule.loadTechnologies();
    CommonModule.loadITSystems();
  }

  update(state: Partial<OrganisationState>) {
    OrganisationModule.update(state);
  }

  assign(state: Partial<OrganisationState>) {
    OrganisationModule.assign(state);
  }

  async save() {
    try {
      const success = await OrganisationModule.save();
      this.showSaveSuccess = success;
    } catch (e) {
      this.showSaveError = true;
    }
  }

  chooseLogo(files: FileList) {
    Array.from(files).forEach(file => {
      this.logoPlaceholder = {
        fileName: file.name,
        file
      };
    });
    this.clearFileInput();
  }

  async removeLogo() {
    await OrganisationModule.removeLogo();
    this.logoPlaceholder = null;
  }

  clearFileInput() {
    const input = this.$refs.fileInput as HTMLInputElement;
    input.type = 'text';
    input.type = 'file';
  }

  async uploadFiles() {
    if (this.logoPlaceholder != null && this.logoPlaceholder.file.size < this.maxFileSize) {
      await OrganisationModule.uploadLogo(this.logoPlaceholder);
      this.logoPlaceholder = null;
    } else {
      this.assign({ showUploadError: true });
    }
  }

  searchUser(name: string) {
    const request: UserSearchRequest = { name: `${name}`, cvr: '' };
    if (AuthModule.user) {
      request.cvr = AuthModule.user.cvr;
      CommonModule.searchUsers(request);
    } else {
      CommonModule.searchUsers(request);
    }
  }
}
